import api from '../../../../../../admin/api/api';

export default {
    namespaced: true,
    state: {
        report: [],
    },
    mutations: {
        setReport(state, report){
            if (report && state.report.id !== report.id) {
                state.report = report;
            }
        },
        spliceReport(state) {
            state.report = [];
        },
    },
    actions: {
        getReport({commit, rootState}){
            api.get('/report/' + rootState.consultation.id).then(response => {
                commit('setReport', response.data.report);
            });
        },
        postReport({commit, rootState}, data){
            api.post('/report/' + rootState.consultation.id + '/upload', data,  {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                commit('setReport', response.data);
            }).catch(error => {
                ErrorAlert.$emit('errorMessage', error.response.data.errors.file[0]);
            });
        },
        deleteReport({commit, rootState}){
            api.post('/report/' + rootState.consultation.id + '/delete').then(response => {
                commit('spliceReport');
            }).catch(error => {
                alert(error);
            });
        }
    }
}
